import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { SkillFormItem } from '../SkillFormItem'
import { SkillList } from '../SkillList'
import { StyledSkillCategoryContainerProps } from './types'

const SkillDetails = styled.details`
  border-bottom: 1px solid ${props => props.theme.members.colors.silver._30};
  padding-top: 12px;
`

const SkillSummary = styled.summary`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  list-style: none;
  padding: 0 16px;

  ${SkillDetails}[open] & {
    border-bottom: 1px solid ${props => props.theme.members.colors.silver._30};
    padding-bottom: 12px;
  }

  ${SkillDetails}:not([open]) & {
    padding-bottom: 12px;
  }
`
const StyledIcon = styled(FontAwesomeIcon)`
  transition: transform 0.3s ease;
  color: ${props => props.theme.members.colors.silver._70};

  ${SkillDetails}[open] & {
    transform: rotate(180deg);
  }
`

const KarteSkill = styled.div`
  background-color: ${props => props.theme.members.colors.silver._10};
  padding: 1rem;

  @media ${props => props.theme.media.sm} {
    padding: 1.5rem;
  }
`

export const StyledSkillCategoryContainer: React.FC<StyledSkillCategoryContainerProps> = props => {
  return (
    <SkillDetails data-cy={`skill-category-${props.categoryId}`}>
      <SkillSummary data-cy="skill-category-summary">
        {props.categoryName}
        <StyledIcon icon={faChevronDown} fontSize={11} />
      </SkillSummary>
      <KarteSkill>
        <SkillFormItem
          categoryName={props.categoryName}
          categoryId={props.categoryId}
          skillOption={props.skillOption}
          errorMessages={props.errorMessages}
        />
        <SkillList categoryId={props.categoryId} />
      </KarteSkill>
    </SkillDetails>
  )
}
